import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useServices } from "@/services-context";
import FixText from "@/elements-react/fix-text";
import { LayoutStyleTypes, LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";

interface OnRequestProps {
  dispatchSelectedQuantity?: number;
}

export const OnRequest: React.FC<OnRequestProps> = ({ dispatchSelectedQuantity }) => {
  const { t } = useTranslation();
  const layoutType = useLayoutType();
  const layout = layoutType.layoutType ?? LayoutTypes.TYPE_DESKTOP;

  const descriptionText = `${t(
    "na9psr8fhb9o4wah.but-we-have-an-official-on-request",
    "But we have an official replacement from the manufacturer. To send a request, write to"
  )} <a href="mailto:sales@fixparts-online.com">sales@fixparts-online.com</a>`;

  return (
    <div className={styles.root}>
      <div
        className={classNames(
          styles.arrowUp,
          layout === LayoutTypes.TYPE_MOBILE && styles.mobileArrowUp
        )}
      />
      <div className={styles.content}>
        <div className={styles.title}>
          {t(
            "ansudpf894oiwahn.product-is-no-longer-produced",
            "This product is no longer produced – only {{quantity}} units left in stock",
            { quantity: dispatchSelectedQuantity }
          )}
        </div>
        <div>
          <div
            className={styles.contentSegment}
            style={{ marginBottom: 0, paddingBottom: 0 }}
          >
            <FixText type={LayoutStyleTypes.TYPE_LG} text={descriptionText} />
          </div>
        </div>
      </div>
    </div>
  );
};

